import { ChampionshipInfoForm } from 'modules/championship/ui/components/championship-form';
import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import { TourneyEncoded } from 'modules/tournaments/domain/interfaces/tourney-encoded';
import React from 'react';
import TourneysComponentsCreateFormTabs from './tabs';

type Props = {
  onSubmit: (data: Partial<TourneyEncoded>) => any;
};

const TourneyComponentsCreateForm = (props: Props) => {
  const { info } = useOrganizer();

  if (!info) {
    return null;
  }

  return (
    <>
      <div className="w-full px-6 py-6">
        <TourneysComponentsCreateFormTabs />
      </div>
      <ChampionshipInfoForm tournamentId={info!.id} />
    </>
  );
};

export default TourneyComponentsCreateForm;
